import { createRoutine } from 'redux-saga-routines';

export const changeLocale = createRoutine('CHANGE_LOCALE'); // eslint-disable-line import/prefer-default-export
